import { useEffect, useRef } from 'react';
import { useUnsoldLeadDetails } from '../context/UnsoldLeadDetailsContext';

export const useLeadIntelligence = () => {
  const {
    leadIntelligenceStreamingText,
    leadIntelligenceIsStreaming,
    leadIntelligenceConversationId,
    leadIntelligenceLoading,
    leadIntelligenceError,
    initLeadIntelligence,
  } = useUnsoldLeadDetails();

  useEffect(() => {
    // Automatically initialize when conversation_id is available
    if (!leadIntelligenceConversationId && !leadIntelligenceLoading) {
      console.log('🚀 Auto-initializing Lead Intelligence...');
      initLeadIntelligence();
    }
  }, [leadIntelligenceConversationId, leadIntelligenceLoading, initLeadIntelligence]);

  useEffect(() => {
    console.log('📊 Lead Intelligence state:', {
      streamingText: leadIntelligenceStreamingText?.substring(0, 50),
      isStreaming: leadIntelligenceIsStreaming,
      conversationId: leadIntelligenceConversationId,
      loading: leadIntelligenceLoading,
    });
  }, [leadIntelligenceStreamingText, leadIntelligenceIsStreaming, leadIntelligenceConversationId, leadIntelligenceLoading]);

  return {
    streamingText: leadIntelligenceStreamingText,
    isStreaming: leadIntelligenceIsStreaming,
    conversationId: leadIntelligenceConversationId,
    loading: leadIntelligenceLoading,
    error: leadIntelligenceError,
  };
};
